module.exports = __webpack_public_path__ + "static/children-become-3e248cae505214b59dd716b23f7c0a7d.png";